__turbopack_context__.v({
  "category": "FileSystem-module__DxYoQG__category",
  "category__content": "FileSystem-module__DxYoQG__category__content",
  "category__header": "FileSystem-module__DxYoQG__category__header",
  "item": "FileSystem-module__DxYoQG__item",
  "itemImage": "FileSystem-module__DxYoQG__itemImage",
  "searchButton": "FileSystem-module__DxYoQG__searchButton",
  "searchMask": "FileSystem-module__DxYoQG__searchMask",
});
